import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input } from "antd";
import jwt_decode from "jwt-decode";
import Button from "../../buttons/Button";
import FormLabel from "../../formLabel/FormLabel";
import userServiceApi from "../../api/userServiceApi";
import { getRequest, postRequest } from "../../api/http";
import { SyncOutlined } from "@ant-design/icons";
import { inputFieldCharLimit } from "../../config";

export default function LoginForm() {
  // const [loading, setLoading] = useState(false);
  const [loginAlert, setLoginAlert] = useState(false);
  const [wrongCred, setWrongCred] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleLogin = async (values) => {
    const trimmedPayload = {
      email:values?.email?.trim(),
      password: values?.password?.trim()
    }
    setLoading(true);
    try {
      const response = await postRequest(userServiceApi.login(), trimmedPayload);
      if (response) {
        sessionStorage.setItem("token", response.accessToken);
        sessionStorage.setItem("refresh", response.refreshToken);
        const decoded = jwt_decode(response.accessToken);
        sessionStorage.setItem("loginPage", "false");

        sessionStorage.setItem("OrgEmail", decoded.email);
        // navigate("/");
        if (decoded.role === "PARTNER_ADMIN") {
          try {
            const headers = {
              Authorization: `Bearer ${response.accessToken}`,
            };
            const OrgResponse = await getRequest(
              userServiceApi.partnerDetails(),
              { headers }
            );
            if (OrgResponse.data) {
              sessionStorage.setItem("partnerId", OrgResponse.data.id);
              sessionStorage.setItem("OrgImage", OrgResponse.data.mediaLink);
              sessionStorage.setItem("OrgName", OrgResponse.data.subDomainName);

              navigate("/partner-org");
            }
          } catch (error) {
            // toast.error(error.message);
            setLoading(false);
          }
        } else {
          setLoading(false);
          setWrongCred(true);
        }
      } else {
        setLoginAlert(true);
        setLoading(false);
      }
    } catch (error) {
      // toast.error(error.error);
      setLoading(false);
    }
  };

  return (
    <div>
 <div className="login-form-container">
      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        className="form-container"
        onFinish={(values) => handleLogin(values)}
      >
        <Form.Item
          label={<FormLabel label="User name" className="form-label" />}
          name="email"
           normalize={(value) => value?.trim()}
          rules={[
            {
              required: true,
              message: "Please enter your User Name",
            },
            {
              type: "email",
              message: "Invalid UserName",
            },
          ]}
        >
          <Input maxLength={inputFieldCharLimit} className="userName-field" placeholder="User name" />
        </Form.Item>
        <Form.Item
          label={<FormLabel label="Password" className="form-label" />}
          name="password"
          rules={[
            {
              required: true,
              message: "Please enter your password",
            },
          ]}
        >
          <Input.Password maxLength={inputFieldCharLimit} className="pwd-field" placeholder="Enter password" />
        </Form.Item>
        {loginAlert ? (
          // console.log("alert")
          <label style={{ color: "red" }}>
            You have entered an invalid username or password
          </label>
        ) : wrongCred ? (
          <label style={{ color: "red" }}>
            Please login using partner admin credentials
          </label>
        ) : (
          ""
        )}
        <Button
          label="Login"
          width="100%"
          type="submit"
          className="login-button"
          loading={loading && <SyncOutlined spin />}
        />
      </Form>
    </div>
    </div>
   
  );
}
